import {ifAuthenticated} from "@/router";

export default [
    {
        path: "/",
        name: "dashboardIndex",
        beforeEnter: ifAuthenticated,
        component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/Index.vue"),
    },
];